import { Components, ComponentsOverrides } from '@mui/material/styles';
import { Theme } from '@mui/material';
import { flowAlert } from '../alert/alert.theme';

export const flowSnackbarContent: Components<Theme>['MuiSnackbarContent'] = {
  styleOverrides: {
    root: flowAlert.styleOverrides.root,
    message: flowAlert.styleOverrides.message,
    action: flowAlert.styleOverrides.action,
    // ignore missing properties of snackbar that are in the flowAlert
  } as ComponentsOverrides<Theme>['MuiSnackbarContent'],
};
